<template>
  <b-container>
    <b-row class="mt-4">
      <b-btn v-b-modal.add-award variant="success">Add Award</b-btn>
    </b-row>
    <b-row>
      <b-table responsive striped hover :items="getAwards" :fields="fields">
        <template v-slot:cell(#)="data">{{data.index + 1}}</template>
        <template v-slot:cell(description)="data">{{data.item.description}}</template>
        <template v-slot:cell(language)="data">{{data.item.language}}</template>
        <template v-slot:cell(minimumScore)="data">{{data.item.minimumScore}}</template>
        <template v-slot:cell(action)="data">
          <b-button size="sm" variant="info" class="ml-2" @click="editAward(data.item)">Edit</b-button>
          <b-button size="sm" class="ml-2" variant="danger" @click="deleteAward(data.item)">Delete</b-button>
        </template>
      </b-table>
    </b-row>

    <b-modal id="add-award" title="Add New Award" ref="modal" @ok="addOrEditAward">
      <div v-if="show">
        <b-form>
          <b-form-group id="input-group-3" label="Select Language:" label-for="input-3">
            <b-form-select v-model="selectedLanguage">
              <option v-for="lang in languages" :key="lang.code" :value="lang">{{ lang.name }}</option>
            </b-form-select>
          </b-form-group>

          <b-form-group id="input-group-1" label="Award Description:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="description"
              type="text"
              required
              placeholder="Enter Award Description here..."
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            label="Enter Minimum Score(integer):"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="minimumScore"
              type="number"
              required
              placeholder="Enter Score Minimum Score here..."
            ></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { db } from "../../db";
import { languages } from "../../utils/constants";
export default {
  data() {
    return {
      show: true,
      fields: [
        { key: "#", sortable: false },
        { key: "description", sortable: false },
        { key: "language", sortable: false },
        { key: "minimumScore", sortable: false },
        { key: "action", sortable: false }
      ],

      languages: languages,
      description: "",
      selectedLanguage: null,
      minimumScore: 0,
      updateOperation: false,
      seletectedAward: null
    };
  },
  computed: {
    getAwards() {
      return this.$store.getters.getAwards;
    }
  },
  created() {
    if (this.$store.getters.getAwards.length == 0) {
      this.setAwards();
    }
    if (this.$store.getters.getModules.length == 0) {
      this.$store.dispatch("setModules");
    }
  },

  methods: {
    addOrEditAward(awardEvnt) {
      awardEvnt.preventDefault();
      this.handleAddAward();
      //console.log(data);
    },

    showAlert() {
      this.$swal.fire({
        title: "Required Fields",
        text: "Please select all fields before submitting!",
        type: "error",

        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33"
      });
    },

    handleAddAward() {
      if (this.validateAwardForm()) {
        let data = {
          description: this.description,
          language: this.selectedLanguage.name,
          minimumScore: this.minimumScore
        };

        if (!this.updateOperation) {
          db.collection("awards").add(data);
        } else {
          db.collection("awards")
            .doc(this.seletectedAward.id)
            .update(data);
        }
        this.setAwards();
        this.resetForms();
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      } else {
        this.showAlert();
      }
    },
    validateAwardForm() {
      if (
        this.selectedLanguage !== null &&
        this.description !== "" &&
        this.minimumScore !== null
      )
        return true;
      else return false;
    },
    editAward(data) {
      this.seletectedAward = data;
      this.updateOperation = true;
      //Populate data
      this.description = data.description;
      this.minimumScore = data.minimumScore;
      this.selectedLanguage = this.languages.find(lang => {
        return lang.name == data.language;
      });

      this.$refs.modal.show();
    },

    deleteAward(data) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            db.collection("awards")
              .doc(data.id)
              .delete();
            this.setAwards();
          }
        });
    },
    resetForms() {
      this.selectedLanguage = null;
      this.description = "";
      this.minimumScore = null;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    setAwards() {
      this.$store.dispatch("setAwards");
    }
  }
};
</script>